/**
 * Shared Validation Constants
 * Used to unify validation logic across CMS and API
 */

export const PHONE_REGEX = /^\d{10}$/;
export const TAX_ID_REGEX = /^\d{13}$/;
export const BANK_ACCOUNT_REGEX = /^\d{10}$/;

export const ERROR_MESSAGES = {
  REQUIRED: "This field is required",
  INVALID_EMAIL: "Invalid email format",
  INVALID_URL: "Invalid URL format",
  PHONE_FORMAT: "Phone number must be exactly 10 digits",
  TAX_ID_FORMAT: "Tax ID must be exactly 13 digits",
  BANK_ACCOUNT_FORMAT: "Bank account number must be exactly 10 digits",
  BONUS_RATE_RANGE: "Bonus rate must be between 0 and 100",
  BONUS_AMOUNT_MIN: "Bonus amount cannot be negative",
  QUOTA_LIMIT_POSITIVE: "Quota limit must be a positive integer",
  MIN_CHARS: (min) => `Must be at least ${min} characters`,
  
  // Password specific
  CURRENT_PASSWORD_REQUIRED: "Current password is required",
  NEW_PASSWORD_REQUIRED: "New password is required",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required",
  PASSWORDS_MUST_MATCH: "Passwords must match",
  NEW_PASSWORD_SAME_AS_OLD: "New password must be different from current password",

  // Field specific
  FIRST_NAME_REQUIRED: "First name is required",
  LAST_NAME_REQUIRED: "Last name is required",
  EMAIL_REQUIRED: "Email is required",
  SKU_REQUIRED: "SKU is required",
  NAME_REQUIRED: "Name is required",
  NAME_ENG_REQUIRED: "English name is required",
  CATEGORY_NAME_REQUIRED: "Category name is required",
  BRAND_NAME_REQUIRED: "Brand name is required",
  CONTENT_NAME_REQUIRED: "Content topic is required",
  CONTENT_URL_REQUIRED: "Content URL is required",
  PRICE_REQUIRED: "Price is required",
  ADDRESS_REQUIRED: "Address is required",
  POSTAL_CODE_FORMAT: "Postal code must be 5 digits",
  PROVINCE_REQUIRED: "Province is required",
  SUB_DISTRICT_REQUIRED: "Sub-district is required",
  DISTRICT_REQUIRED: "District is required",
  TRANSACTION_ID_REQUIRED: "Transaction ID is required",
  BONUS_AMOUNT_REQUIRED: "Bonus amount is required",
  PRODUCT_MIN_REQUIRED: "At least one product is required",
  TRACKING_DATA_REQUIRED: "Tracking data is required",
  COMMISSION_RATE_RANGE: "Commission rate must be between 0 and 100",
  DATE_START_REQUIRED: "Start date is required",
  DATE_END_REQUIRED: "End date is required",
  INVALID_NUMBER: "Must be a number",
  AMOUNT_MIN: (min) => `Amount must be at least ${min}`,
  
  // Generic
  MIN_VALUE: (min) => `Value must be at least ${min}`,
  MAX_VALUE: (max) => `Value must be at most ${max}`,
  MAX_CHARS: (max) => `Must be at most ${max} characters`,
  MIN_CHARS: (min) => `Must be at least ${min} characters`,
};

export const POSTAL_CODE_REGEX = /^\d{5}$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,100}$/;
